export function createFomoBenefits({
  root: landing,
  isPaused,
  isReduced,
  requestUpdate,
  listen,
  observeSize,
}) {
  const root = landing.querySelector(".conversion-benefits");
  const sticky = root.querySelector(".benefit-sticky");
  const stage = root.querySelector("#benefit-demo");
  const controls = [...root.querySelectorAll("[data-benefit]")];
  const copies = [...root.querySelectorAll("[data-benefit-copy]")];
  const panels = [...root.querySelectorAll("[data-benefit-panel]")];
  const clamp = (x) => Math.max(0, Math.min(1, x)),
    ease = (x) => x * x * (3 - 2 * x);
  let active = -1,
    manual = 0,
    purchase = 0,
    forcedPurchase = null,
    purchaseAnimation = null;
  const path = root.querySelector("#funds-path"),
    pathLength = path.getTotalLength();
  const packets = [...root.querySelectorAll(".funds-packet")];
  function setScene(index) {
    if (index === active) return;
    active = index;
    stage.dataset.benefitScene = String(index);
    root.querySelector("#benefit-index").textContent = String(
      index + 1
    ).padStart(2, "0");
    controls.forEach((button, i) =>
      button.setAttribute("aria-pressed", String(i === index))
    );
    [...copies, ...panels].forEach((el) => {
      const selected =
        Number(el.dataset.benefitCopy ?? el.dataset.benefitPanel) === index;
      el.classList.toggle("is-active", selected);
      el.setAttribute("aria-hidden", String(!selected));
      el.inert = !selected;
    });
    if (index !== 0) {
      forcedPurchase = null;
      purchaseAnimation = null;
    }
  }
  function update() {
    const header = landing.querySelector(".site-header").offsetHeight;
    const length = Math.max(1, root.offsetHeight - sticky.offsetHeight);
    const p = isReduced()
      ? (manual + 0.62) / 3
      : clamp((header - root.getBoundingClientRect().top) / length);
    const raw = p * 3,
      index = Math.min(2, Math.floor(raw)),
      local = raw >= 3 ? 1 : raw - index;
    const phase = isReduced() || isPaused() ? 0.88 : ease(clamp(local / 0.88));
    setScene(index);
    stage.style.setProperty("--benefit-phase", phase.toFixed(4));
    sticky.style.setProperty("--benefit-progress", local.toFixed(4));
    let done =
      forcedPurchase === null
        ? ease(clamp((local - 0.38) / 0.4))
        : forcedPurchase;
    if ((isReduced() || isPaused()) && forcedPurchase === null) done = 1;
    if (purchaseAnimation) {
      const ratio =
        isReduced() || isPaused()
          ? 1
          : clamp((performance.now() - purchaseAnimation.start) / 750);
      done =
        purchaseAnimation.from +
        (purchaseAnimation.to - purchaseAnimation.from) * ease(ratio);
      if (ratio < 1) requestUpdate();
      else {
        forcedPurchase = purchaseAnimation.to;
        purchaseAnimation = null;
      }
    }
    purchase = done;
    stage.style.setProperty("--purchase-done", done.toFixed(4));
    root
      .querySelector(".phone-checkout")
      .setAttribute("aria-hidden", String(done > 0.5));
    root
      .querySelector(".phone-success")
      .setAttribute("aria-hidden", String(done <= 0.5));
    const buyButton = root.querySelector("#benefit-buy-demo");
    buyButton.dataset.complete = String(done > 0.95);
    buyButton.querySelector("span").textContent =
      done > 0.5 ? "Ver desde el inicio" : "Ver la compra";
    packets.forEach((packet, i) => {
      const travel = (phase * 0.85 + i * 0.23) % 1,
        point = path.getPointAtLength(pathLength * travel);
      packet.setAttribute("cx", point.x.toFixed(2));
      packet.setAttribute("cy", point.y.toFixed(2));
      packet.style.opacity = (Math.sin(travel * Math.PI) * 0.95).toFixed(3);
    });
  }
  function go(index) {
    manual = index;
    forcedPurchase = null;
    purchaseAnimation = null;
    if (isReduced()) {
      update();
      root.scrollIntoView({
        block: "start",
        behavior: "auto",
      });
      return;
    }
    const header = landing.querySelector(".site-header").offsetHeight;
    const top = root.getBoundingClientRect().top + scrollY - header;
    window.scrollTo({
      top:
        top + (root.offsetHeight - sticky.offsetHeight) * ((index + 0.6) / 3),
      behavior: isPaused() ? "instant" : "smooth",
    });
  }
  controls.forEach((button, index) => listen(button, "click", () => go(index)));
  listen(root.querySelector("#benefit-buy-demo"), "click", () => {
    purchaseAnimation = {
      from: purchase,
      to: purchase > 0.5 ? 0 : 1,
      start: performance.now(),
    };
    requestUpdate();
  });
  listen(root.querySelector("#benefit-brand-demo"), "click", () => {
    const experience = root.querySelector(".brand-experience");
    const next = experience.dataset.style === "0" ? "1" : "0";
    experience.dataset.style = next;
    root
      .querySelector("#benefit-brand-demo")
      .setAttribute(
        "aria-label",
        next === "1" ? "Ver portada con luces" : "Ver portada de concierto"
      );
  });
  observeSize(root, requestUpdate);
  return {
    update,
  };
}
